interface Options {
  backgoundColor: string;
  color: string;
  x: number;
  y: number;
}

export const TooltipStyles = (options: Options) => ({
  backgroundColor: `${options.backgoundColor}`,
  boxShadow: '0 0 10px rgba(black, 0.2)',
  color: `${options.color}`,
  left: `${options.x}px`,
  padding: '10px',
  position: 'absolute',
  top: `${options.y - 50}px`,
  zIndex: 10,
});
